import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './css/PlaceholderComponent3.css';

const PlaceholderComponent3 = (props) => {
    const { text } = props;

    return (
        <div className="placeholder-component1 alegreya-font-family p-t-100px p-b-20px font-size-3xl font-weight-800 text-uppercase text-center-align">
            <p>{text}</p>
        </div>
    );
};

PlaceholderComponent3.propTypes = {
    text: PropTypes.string.isRequired,
};

export default memo(PlaceholderComponent3);
